import { lazy } from "react";

import type { NavigationRoutingObject } from "@navigationRouting/types";

import type { I18nT } from "@lib/dashboardI18n";

const VouchersSection = lazy(() =>
  import("@scenes/PromotionCodes/components/VouchersSection").then((module) => ({
    default: module.VouchersSection,
  }))
);

export const promotionCodesNRO: NavigationRoutingObject = {
  Component: VouchersSection,
  componentFeatureFlippers: [],
  noKnockoutFallback: true,
  section: "data-settings",
  heading: (t: I18nT<"dashboard-navigation">) => t("promotion-codes-menu-option", "Promotion Codes"),
  description: (t: I18nT<"dashboard-navigation">) =>
    t("promotion-codes-description-nav", "Create promotion code lists with custom expiration dates"),
  icon: "nav-system-promotion-codes",
  getDeveloperNavigationAllowed: () => true,
  additionalSearchTerms: () => [],
  additionalSearchableFeatures: () => ({}),
  defaultRoute: "/integrations/vouchers/vouchers/:appGroupId",
};
